/**
 * Embed Poster — click the poster to load and autoplay the deferred iframe.
 *
 * The poster markup and the iframe's deferred data-embed-src are both
 * rendered by EmbedPoster::inject_poster()
 * (src/php-lib/BlockExtensions/EmbedPoster.php).
 */
const POSTER_SELECTOR = '.wp-embed-poster';

document.querySelectorAll(POSTER_SELECTOR).forEach((poster) => {
  const wrapper = poster.closest('.wp-block-embed__wrapper');
  const iframe = wrapper?.querySelector('iframe[data-embed-src]');

  if (!iframe) return;

  poster.addEventListener(
    'click',
    () => {
      const src = iframe.getAttribute('data-embed-src');
      const separator = src.includes('?') ? '&' : '?';

      iframe.setAttribute('src', `${src}${separator}autoplay=1`);
      poster.remove();
    },
    { once: true }
  );
});
